import { ArrowUpRight, UtensilsCrossed } from 'lucide-react';
import { RESTAURANT } from '../constants/restaurant';

export const Hero = () => {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden bg-brand-coffee"
    >
      {/* Background */}
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{
          backgroundImage:
            "url('https://images.pexels.com/photos/9792458/pexels-photo-9792458.jpeg')",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-brand-coffee/85 via-brand-coffee/60 to-brand-coffee/95" />
      <div className="absolute inset-0 grain-overlay" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-16 min-h-[100svh] flex flex-col justify-center pt-28 pb-32 md:pb-24">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-3 mb-7 px-4 py-2 rounded-full bg-brand-cream/10 border border-brand-cream/20 backdrop-blur-md">
            <span className="w-2 h-2 rounded-full bg-brand-gold animate-pulse" />
            <span
              data-testid="hero-eyebrow"
              className="text-[11px] md:text-xs tracking-[0.28em] uppercase text-brand-cream font-semibold"
            >
              South Indian · Maroochydore · Sunshine Coast
            </span>
          </div>

          <h1
            data-testid="hero-heading"
            className="font-serif text-[44px] leading-[1.02] sm:text-6xl lg:text-[78px] text-brand-cream tracking-tight text-balance"
          >
            Home of the
            <br />
            Famous <span className="italic text-brand-gold">Sankalp Dosa</span>
            <br />
            on the Sunshine Coast
          </h1>

          <p
            data-testid="hero-subheading"
            className="mt-7 max-w-xl text-base md:text-lg text-brand-cream/85 leading-[1.65]"
          >
            Experience the authentic taste of India with Sankalp&apos;s famous crispy
            dosas, authentic South Indian specialties, and a delicious selection of
            Indian favourites. Enjoy freshly prepared dishes with warm hospitality —
            available for dine-in, takeaway, and delivery.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href={RESTAURANT.orderUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-order-btn"
              className="group inline-flex items-center justify-center gap-3 px-7 py-4 rounded-full bg-brand-burgundy text-brand-cream font-semibold text-sm tracking-[0.2em] uppercase shadow-[0_20px_50px_rgba(139,26,26,0.35)] hover:-translate-y-1 hover:bg-brand-burgundy/90 transition-all duration-500"
            >
              <UtensilsCrossed className="w-4 h-4" />
              Order Online
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
            </a>
            <a
              href={RESTAURANT.bookUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-book-btn"
              className="group inline-flex items-center justify-center gap-3 px-7 py-4 rounded-full border border-brand-cream/40 text-brand-cream font-semibold text-sm tracking-[0.2em] uppercase hover:bg-brand-cream hover:text-brand-coffee transition-all duration-500 backdrop-blur-sm"
            >
              Book a Table
              <ArrowUpRight className="w-4 h-4 transition-transform group-hover:rotate-45" />
            </a>
          </div>
        </div>

        {/* Bottom info strip */}
        <div className="hidden md:grid absolute bottom-12 left-0 right-0 mx-auto max-w-7xl px-6 md:px-12 lg:px-16 grid-cols-3 gap-8 text-brand-cream/80">
          <InfoItem label="Hours" value="Lunch & Dinner · 7 days" />
          <InfoItem label="Cuisine" value="South Indian · Dosas · Biryani · Curries" />
          <InfoItem label="Call us" value={RESTAURANT.phone} href={`tel:${RESTAURANT.phoneRaw}`} />
        </div>
      </div>
    </section>
  );
};

const InfoItem = ({ label, value, href }) => {
  const Tag = href ? 'a' : 'div';
  return (
    <Tag
      {...(href ? { href } : {})}
      className="flex flex-col gap-1 hover:text-brand-gold transition"
    >
      <span className="text-[10px] uppercase tracking-[0.28em] text-brand-cream/60 font-semibold">
        {label}
      </span>
      <span className="font-serif text-xl text-brand-cream">{value}</span>
    </Tag>
  );
};

export default Hero;
